import React, { FC, ReactElement } from 'react';
import cn from 'classnames';
import stylesLoadingIndicator from './loading-indicator.module.scss';
import stylesSpinner from './spinner.module.scss';

type TLoadingIndicatorProps = {
  size?: 'small';
  centred?: boolean;
};

type TSpinnerProps = {
  active: boolean;
};

const LoadingIndicator: FC<TLoadingIndicatorProps> = ({ size, centred }) => (
  <div
    data-testid="loading-indicator"
    className={cn(
      stylesLoadingIndicator.spinner,
      size && stylesLoadingIndicator[size],
      centred && stylesLoadingIndicator.centred,
    )}
  />
);

export default function Spinner({
  active,
}: TSpinnerProps): ReactElement | null {
  return active ? (
    <div data-testid="spinner" className={stylesSpinner.spinnerWrap}>
      <LoadingIndicator />
    </div>
  ) : null;
}
